import * as R from 'remeda';
import { Reducer } from 'redux';
import { getType } from 'typesafe-actions';
import { RootActionType } from '../../rootActions';
import { clearAnnotationData } from '../annotation/actions';
import { logoutUser } from '../auth/actions';
import { leaveValidation } from '../ui/actions';
import { fetchSchemaFulfilled } from './actions';
import { SchemaState } from './types';

const initialState: SchemaState = {
  content: undefined,
  id: undefined,
  url: undefined,
};

const reducer: Reducer<typeof initialState, RootActionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case getType(fetchSchemaFulfilled):
      return R.mergeDeep(state, R.omit(action.payload, ['metadata']));

    case getType(leaveValidation):
    case getType(logoutUser):
    case getType(clearAnnotationData):
      return initialState;

    default:
      return state;
  }
};

export default reducer;
